<ng-container [ngSwitch]="props.cardSetLayoutOptions?.layoutType || 'card'">
  <ng-container *ngSwitchCase="'card'">
    <p-card [subheader]="props.description">
      <ng-template pTemplate="content">
        <ng-container *ngTemplateOutlet="layoutTypeContent"></ng-container>
      </ng-template>
    </p-card>
  </ng-container>
  <ng-container *ngSwitchCase="'plain'">
    <dspx-heading [level]="props.headingLevel" [heading]="props.label"></dspx-heading>
    <dspx-description [text]="props.description"></dspx-description>
    <ng-container *ngTemplateOutlet="layoutTypeContent"></ng-container>
  </ng-container>
  <ng-template #layoutTypeContent>
    <p-panel [collapsed]="field.props.isCollapsed">
      <ng-template pTemplate="header">
        <div id={{field.key}}-panel-header class="panel-header">
          <div class="col-4 flex items-center">
            <span>{{props.label}}</span>
            <span *ngIf="isSectionMandatory">*</span>
          </div>
          <div class="flex items-center">
            <formly-field [field]="existsField"></formly-field>
          </div>
          <div class="flex items-center">
            <formly-field [field]="notAssessedField"></formly-field>
          </div>
          <span>{{field.props.answeredQuestionCount}}/{{field.props.totalQuestionCount}}</span>
          <button pButton
                  type="button"
                  class="p-button-text p-button-sm" [disabled]="!field.props.exists || field.props.notAssessed"
                  (click)="setCollapsedStatus(field)">
            {{ field.props.isCollapsed ? 'Show' : 'Hide' }}
          </button>
        </div>
      </ng-template>
      <div *ngIf="!field.props.isCollapsed">
        <!-- Display existing data -->
        <div class="mb-4 p-3 existingDataDisplay" *ngIf="existingData?.length">
          <h4 class="existingDataDisplayHeader">Previous Inspection Data</h4>
          <span><strong>Last inspected on: </strong>{{lastInspectionDate}}</span>
          <ng-container *ngFor="let group of getGroupedData()">
            <div class="mb-2 mt-3">
              <strong>Item {{ group.displayItemNo }}:</strong>
            </div>

            <ul class="list-unstyled ms-3">
              <li *ngFor="let prop of group.items">
                <strong>{{ getQuestionLabel(prop.label) }}:</strong> {{ getDisplayValue(prop.value, prop.fieldType) }}
              </li>
            </ul>
          </ng-container>
          <div>
            <button 
                pButton
                type="button"
                class="ml-2"
                [disabled]="!canUseExistingData"
                [label]="'Use Existing Data'"
                [title]="'Use Existing Data'"
                icon="pi pi-copy"
                (click)="onUseExistingData()">
            </button>
          </div>
        </div>
        <dspx-table-repeater-custom [sectionLabel]="props.label"
                                    [repeater]="baseTableRepeater"
                                    [renderItemsAsSeparateFieldTypes]="false"
                                    [repeaterLayout]="props.cardSetLayoutOptions?.repeaterLayout"
                                    [hideCustomHeaderWhenExpanded]="props.cardSetLayoutOptions?.hideCustomHeaderWhenExpanded"
                                    [hideCustomSubHeaderWhenExpanded]="props.cardSetLayoutOptions?.hideCustomSubHeaderWhenExpanded"
                                    (onInitialiseCompleted)="onTableRepeaterInitialised($event)">
        </dspx-table-repeater-custom>        
      </div>
    </p-panel>
  </ng-template>
</ng-container>
